//
// Exports
//
export * from './matchers/compat';
export * from './matchers/map';
export * from './matchers/mount';
export * from './matchers/redirect';
export * from './matchers/route';
export * from './matchers/withContext';
export * from './matchers/withData';
export * from './matchers/withHead';
export * from './matchers/withHeaders';
export * from './matchers/withStatus';
export * from './matchers/withTitle';
export * from './matchers/withView';
export * from './Errors';
export * from './NaviRequest';
export * from './Chunks';
export * from './URLTools';
export { compose } from './utils/compose';
export { Router, createRouter } from './Router';
export { defaultRouteReducer } from './Route';
export { concatMatcherIterators } from './Matcher';
export { default as resolveChunks } from './Resolvable';
export { createBrowserNavigation, BrowserNavigation } from './BrowserNavigation';
export { createMemoryNavigation, MemoryNavigation } from './MemoryNavigation';
//
// Aliases
//
export { map as lazy } from './matchers/map';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/navi/dist/es/index.js
// module id = 23
// module chunks = 0